import { Box, SelectChangeEvent, Theme } from "@mui/material";
import { SxProps } from "@mui/system";
import { MultiSelect } from "../multi_select";
import { CONTROL_LABEL_SX } from "../../utils/control_label";
import { getOrderedSegments } from "../../utils/segment_order";

export const SegmentSelect = (props: {
  isLoading: boolean;
  sx?: SxProps<Theme>;
  segments: string[];
  setSegments: (segments: string[]) => void;
  segmentOrder?: string[];
  setSegmentOrder?: (segmentOrder: string[]) => void;
  columns: { name: string; caption: string }[];
}) => {
  const {
    isLoading,
    sx,
    segments,
    setSegments,
    segmentOrder,
    setSegmentOrder,
    columns,
  } = props;

  // Chips display (and are dragged) in the column order; `segments` keeps its
  // own order because it is the transform argument.
  const orderedSegments = getOrderedSegments(segments, segmentOrder);

  return (
    <Box sx={sx}>
      <Box sx={CONTROL_LABEL_SX}>Segment by</Box>
      <MultiSelect
        disabledDeleteValue={"table_id"}
        isLoading={isLoading}
        sx={{ fontSize: 12 }}
        selectedOptions={orderedSegments}
        handleChange={async (event: SelectChangeEvent<string[]>) => {
          const selectedValues = Array.isArray(event.target.value)
            ? event.target.value
            : [event.target.value];
          // MUI derives the new value from the (display-ordered) list we pass
          // in, so writing it straight back would silently rewrite the
          // transform argument's order and change the row sort precedence.
          // Keep the existing segments in their own order and append what's
          // new, so add/remove only ever adds or removes.
          const nextSet = new Set(selectedValues);
          const kept = segments.filter((s) => nextSet.has(s));
          const added = selectedValues.filter((s) => !segments.includes(s));
          setSegments([...kept, ...added]);
        }}
        handleDelete={async (segment: string) => {
          const newSegments = segments.filter((s) => s !== segment);
          setSegments(newSegments);
        }}
        // Display-only: reordering columns never touches `segments`, so no
        // transform re-run fires. See utils/segment_order.
        onReorder={
          setSegmentOrder
            ? (next: string[]) => setSegmentOrder(next)
            : undefined
        }
        // TODO: we should use the caption instead of the name
        options={columns.map((c) => c.name)}
      ></MultiSelect>
    </Box>
  );
};
